import { Language } from '@shared/utils/locale';

export const AVAILABLE_LANGUAGES: Language[] = ['de', 'en', 'es', 'fr', 'it'];
export const DEFAULT_LANGUAGE: Language = 'en';
export const DEFAULT_LOCALE = 'en-US';
